<template>
    <div id="hero" class="form-container home-step" :ref="stepName" style="position:relative">
        <img @click="nextStep()" class="pastille-airfryer-cookbook" src="/images/fr_multigift_carousel/Pastille-Airfryer-Cookbook-nl.png" alt="airfryer cookbook">
        <h4 class="purple-text">Aanbieding alleen geldig voor nieuwe leden</h4>

        <h2>Ontdek <br>
            Testaankoop <br>
            2 maanden lang <br>
            <span class="orange-text">voor €&nbsp;2</span></h2>
        <p>Ontvang 1 gratis e-book <br>
            + 1 Airfryer als welkomstgeschenk</p>
        <b-button class="button is-primary next-button" @click="nextStep()">Vraag je pakket aan</b-button>

        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import {gsap} from 'gsap';
import mixin from "../../../travel_step_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";
import animation_mixin from "../../../animation_engine_mixin";

export default {
    mixins: [mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>
